import { Component, OnInit, Output, EventEmitter,Input } from '@angular/core';
import {Survey} from "../survey/survey";
import { Router } from '@angular/router';
import { ApiService} from "../api.service";
import {CommonService} from '../common.service';

declare var wx: any;

@Component({
    selector: 'app-fail',
    templateUrl: './fail.component.html',
    styleUrls: ['./fail.component.css']
})
export class FailComponent implements OnInit {
    @Output() onRestart = new EventEmitter<any>();
    @Input() survey: any;
    @Input() learningPathId: number;
  assetsRoute: string = "../../assets";
    constructor(private router: Router,
                    private apiService: ApiService,
                private commonService: CommonService) { }

    ngOnInit() {
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var htmlFontSize=document.documentElement.clientWidth/7.5;
        document.documentElement.style.fontSize=htmlFontSize+"px";
        document.documentElement.style.backgroundColor="#3d3d6d";
    }

    ngAfterViewInit(){

    }

    restart(){
      this.onRestart.emit(true);
    }

    closeWindow() {
        let dnaReturnUrl = this.commonService.getStorage('dnaReturnUrl');
        if (dnaReturnUrl) {
          window.location.href = dnaReturnUrl;
          this.commonService.removeStorage('dnaReturnUrl');
        } else {
          if(this.survey.type==1){
            wx.closeWindow();
          }else{
            this.apiService.ajax({
              'type': 'get',
              'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
            }).subscribe(result=>{
              let link = ['learning-path',result];
              this.router.navigate(link);
            });
          }
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/fail/fail.component.ts